import React from 'react';
import TablaImpuestoProDeclarar from '../components/impuestoprodu/tablaImpProDeclarar';

  function ImpuestoProDeclarar() {
    return (
      <div className='col-sm-12 d-flex justify-content-center row'>
          <TablaImpuestoProDeclarar />
      </div>
    );
  }

export default ImpuestoProDeclarar;




// WEBPACK FOOTER //
// ./src/pages/impuestoproducciondeclarar.js